import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import {
  AddDocumentTypeToPermitType,
  AddDocumentTypeToPermitTypeVariables,
} from "./__generated__/AddDocumentTypeToPermitType";

const ADD_DOCUMENT_TYPE_TO_PERMIT_TYPE = gql`
  mutation AddDocumentTypeToPermitType($organizationId: String!, $permitTypeId: String!, $documentTypeId: String!) {
    addDocumentTypeToPermitType(
      input: { organizationId: $organizationId, permitTypeId: $permitTypeId, documentTypeId: $documentTypeId }
    ) {
      permitTypeDocumentType {
        id
        documentType {
          id
          name
          key
          settings {
            declaration
            requirement {
              key
              name
            }
          }
          isArchived
        }
        settings {
          declaration
          requirement {
            key
            name
          }
        }
      }
    }
  }
`;

export function useAddDocumentTypeToPermitType() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddDocumentTypeToPermitType,
    AddDocumentTypeToPermitTypeVariables
  >(ADD_DOCUMENT_TYPE_TO_PERMIT_TYPE, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
